export const customColors = {
  purpleOne: "#635fc7",
  purpleTwo: "#a8a4ff",
  blackOne: "#000112",
  blackTwo: "#20212c",
  blackThree: "#2b2c37",
  blackFour: "#3e3f4e",
  grayOne: "#828fa3",
  grayTwo: "#E4EBFA",
  grayThree: "#f4f7fd",
  white: "#ffffff",
  redOne: "#ea5555",
  redTwo: "#ff9898",
};
